// extracted by mini-css-extract-plugin
export var fadeIn = "_b2-0";